// Brillenhaus – eigene Produktgalerie: Wischen/Pfeile, Vorschaubilder, Zähler und Großansicht.

function initGallery(root) {
  if (root.dataset.bhReady) return;
  root.dataset.bhReady = 'true';
  const track = root.querySelector('[data-bh-gal-track]');
  const slides = [...root.querySelectorAll('[data-bh-gal-slide]')];
  const thumbs = [...root.querySelectorAll('[data-bh-gal-thumb]')];
  const current = root.querySelector('[data-bh-gal-current]');
  const dialog = root.querySelector('[data-bh-gal-dialog]');
  const dialogTrack = root.querySelector('[data-bh-gal-dialog-track]');
  let active = 0;

  const go = (index, smooth = true) => {
    const i = Math.max(0, Math.min(slides.length - 1, index));
    track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: smooth ? 'smooth' : 'auto' });
  };

  const setActive = (i) => {
    if (i === active) return;
    active = i;
    thumbs.forEach((t, k) => t.classList.toggle('is-active', k === i));
    if (current) current.textContent = String(i + 1);
    thumbs[i]?.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
  };

  // Aktives Bild anhand der Scrollposition bestimmen
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting && entry.intersectionRatio > 0.6) setActive(Number(entry.target.dataset.bhGalSlide));
      });
    },
    { root: track, threshold: [0.6] }
  );
  slides.forEach((s) => observer.observe(s));

  root.querySelector('[data-bh-gal-prev]')?.addEventListener('click', () => go(active - 1));
  root.querySelector('[data-bh-gal-next]')?.addEventListener('click', () => go(active + 1));
  thumbs.forEach((t) => t.addEventListener('click', () => go(Number(t.dataset.bhGalThumb))));
  track.addEventListener('keydown', (e) => {
    if (e.key === 'ArrowRight') { e.preventDefault(); go(active + 1); }
    if (e.key === 'ArrowLeft') { e.preventDefault(); go(active - 1); }
  });

  // Großansicht
  root.querySelectorAll('[data-bh-gal-open]').forEach((btn) =>
    btn.addEventListener('click', () => {
      if (!dialog) return;
      dialog.showModal();
      document.documentElement.classList.add('bh-scroll-lock');
      const i = Number(btn.dataset.bhGalOpen);
      requestAnimationFrame(() => dialogTrack.scrollTo({ left: dialogTrack.clientWidth * i, behavior: 'auto' }));
    })
  );
  const close = () => { dialog.close(); };
  root.querySelector('[data-bh-gal-close]')?.addEventListener('click', close);
  dialog?.addEventListener('close', () => document.documentElement.classList.remove('bh-scroll-lock'));
  dialog?.addEventListener('click', (e) => { if (e.target === dialog) close(); });
}

document.querySelectorAll('[data-bh-gal]').forEach(initGallery);
